import { useDeviceTypes } from 'core/contexts/device-types/hooks/use-device-types.hook';
import { ConfigurationDetailProvider } from 'modules/settings/contexts/device-configuration/providers/configuration-detail.provider';
import { ConfigurationListProvider } from 'modules/settings/contexts/device-configuration/providers/configuration-list.provider';
import { useNavigate, useParams } from 'react-router-dom';
import { DeviceConfigurationInfo } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-list/settings-devices-configuration-list.model';
import { SettingsDevicesConfigurationWorkflow } from '../settings-devices-configuration-workflow.component';

export const SettingsDevicesConfigurationLayoutContainer: React.FC = () => {
    const { id, deviceConfigurationId } = useParams();

    const { getDeviceTypeDetailsBySlug } = useDeviceTypes();
    const deviceType = getDeviceTypeDetailsBySlug(id || '');
    const navigate = useNavigate();

    if (!deviceConfigurationId || !id) {
        navigate(-1);
    }

    return (
        <ConfigurationListProvider deviceType={deviceType}>
            <ConfigurationDetailProvider
                deviceConfiguration={{ id: deviceConfigurationId || '' } as DeviceConfigurationInfo}
                deviceType={deviceType}
            >
                <SettingsDevicesConfigurationWorkflow />
            </ConfigurationDetailProvider>
        </ConfigurationListProvider>
    );
};
